// Angular
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

//libraries
import { PaginatorModule } from "primeng/paginator";

// Afidium
import { SearchResultComponent } from './processing-search-result.component';
import { ProcessingSearchResultRouting } from './processing-search-result.routing';
import { SashaBreadcrumbModule } from '../../shared/components/breadcrumb/sasha-breacrumb.module';
import { CardModule } from "libraries/ui_card/card.module";
import { ProcessingResultContainerModule } from "./components/processing-result-container/processing-result-container.module";
import { SearchSummaryModule } from "libraries/component/search-summary/search-summary.module";
import { ProcessingSummaryService } from './processing-summary.service';
import { ProcessingSearchFormModule } from '../../shared/components/processing-search-form/processing-search-form.module';
import { ProcessingResourceModule } from 'app_sasha/shared/resources/processings/processingResource.module';
import { DateRangePipeModule } from 'app_sasha/shared/pipes/dateRange/dateRange.module';
import { TitleServiceModule } from 'app_sasha/shared/services/title/title-service.module';
import { LabelModule } from 'libraries/service/label/label.module';
import { PaginationModule } from "libraries/component/pagination/pagination.module";

@NgModule({
    imports: [
        CardModule,
        CommonModule,
        DateRangePipeModule,
        PaginatorModule,
        ProcessingResourceModule,
        ProcessingResultContainerModule,
        ProcessingSearchFormModule,
        ProcessingSearchResultRouting,
        SashaBreadcrumbModule,
        SearchSummaryModule,
        TitleServiceModule,
        PaginationModule,
        LabelModule,
    ],
    declarations: [
        SearchResultComponent,
    ],
    providers: [
        ProcessingSummaryService,
    ]
})
export class ProcessingSearchResultModule { }
